<template>
    <div>
        <CContainer>
            <CRow class="mb-4">
                <CCol md="12" class="d-flex justify-content-end">
                    <CButton class="mr-2" color="primary" @click="() => { isEdit = !isEdit }" v-if="!isEdit">
                        <div class="button-text">
                            <CIcon name="cil-pencil" />
                            <span>Edit</span>
                        </div>
                    </CButton>
                    <template v-else>
                        <CButton class="mr-2" color="primary" @click="handleSave">
                            <div class="button-text">
                                <CIcon name="cil-check-circle" />
                                <span>Save</span>
                            </div>
                        </CButton>
                        <CButton class="mr-2" color="danger" @click="handleCancel">
                            <div class="button-text">
                                <CIcon name="cil-ban" />
                                <span>Cancel</span>
                            </div>
                        </CButton>
                    </template>
                </CCol>
            </CRow>
            <CRow>
                <CCol md="12">
                    <CCard>
                        <CCardBody>
                            <h3 class="mb-3">Home</h3>
                            <CRow>
                                <CCol sm="4">
                                    <div v-if="homeProduct.product">
                                        <CCard class="pointer">
                                            <CCardBody class="p-6">
                                                <CImg alt="Product Image" :src="homeProduct.product.image[0]"
                                                    class="w-100 mb-3" />
                                                <h4>{{ homeProduct.product.name }}</h4>
                                                <p>{{ moneyFormatter(homeProduct.product.price) }}</p>
                                            </CCardBody>
                                            <CCardFooter class="d-flex justify-content-between">
                                                <CButton block shape="pill" color="light" @click="addProduct(null)"
                                                    :disabled="!isEdit">
                                                    <div class="button-text">
                                                        <div class="button-text">
                                                            <span><b>Replace</b></span>
                                                        </div>
                                                    </div>
                                                </CButton>
                                                <CButton color="danger" variant="ghost" size="sm"
                                                    @click="removeProduct(null)" :disabled="!isEdit">
                                                    <div class="button-text">
                                                        <CIcon name="cil-trash" />
                                                        <span>Remove</span>
                                                    </div>
                                                </CButton>
                                            </CCardFooter>
                                        </CCard>
                                    </div>
                                    <CButton block shape="pill" color="light" @click="addProduct(null)"
                                        :disabled="!isEdit" v-else>
                                        <div class="button-text">
                                            <div class="button-text">
                                                <CIcon name="cil-plus" />
                                                <span><b>Add Product</b></span>
                                            </div>
                                        </div>
                                    </CButton>
                                </CCol>
                                <CCol sm="8">
                                    <p>Content</p>
                                    <vue-editor v-model="homeProduct.description" :editor-toolbar="customToolbar"
                                        :disabled="!isEdit" />
                                    <br>
                                    <p>Chinese Content</p>
                                    <vue-editor v-model="homeProduct.chinese_description" :editor-toolbar="customToolbar"
                                        :disabled="!isEdit" />
                                </CCol>
                            </CRow>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
            <CRow>
                <CCol md="12">
                    <CCard>
                        <CCardBody>
                            <h3 class="mb-3">Elsewhere</h3>
                            <CRow>
                                <CCol sm="3" v-for="(prod, index) in otherProducts" :key="index">
                                    <div v-if="prod">
                                        <CCard class="pointer">
                                            <CCardBody class="p-2">
                                                <CImg alt="Product Image" :src="prod.image[0]" class="w-100 mb-3" />
                                                <CCardSubtitle class="mb-3">{{ prod.name }}</CCardSubtitle>
                                                <CCardSubtitle>{{ moneyFormatter(prod.price) }}</CCardSubtitle>
                                            </CCardBody>
                                            <CCardFooter class="d-flex justify-content-between">
                                                <CButton shape="pill" color="light" size="sm" @click="addProduct(index)"
                                                    :disabled="!isEdit">
                                                    <div class="button-text">
                                                        <span><b>Replace</b></span>
                                                    </div>
                                                </CButton>
                                                <CButton color="danger" variant="ghost" size="sm"
                                                    @click="removeProduct(index)" :disabled="!isEdit">
                                                    <div class="button-text">
                                                        <CIcon name="cil-trash" />
                                                        <span>Remove</span>
                                                    </div>
                                                </CButton>
                                            </CCardFooter>
                                        </CCard>
                                    </div>
                                    <CButton v-else block shape="pill" color="light" @click="addProduct(index)"
                                        :disabled="!isEdit">
                                        <div class="button-text">
                                            <CIcon name="cil-plus" />
                                            <span><b>Add Product</b></span>
                                        </div>
                                    </CButton>
                                </CCol>
                            </CRow>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </CContainer>
        <CModal title="Modal title" :closeOnBackdrop="false" :centered="true" :show.sync="addProductModal.show"
            @update:show="dismissModal" size="lg">
            <CRow>
                <CCol :sm="12">
                    <CInput placeholder="Product Name" v-model="keyword">
                        <template #append>
                            <CButton color="primary" @click="searchProductByName">
                                <CIcon name="cil-magnifying-glass" /> Search
                            </CButton>
                        </template>
                    </CInput>
                </CCol>
            </CRow>
            <CRow v-if="searchList.length">
                <CCol v-for="data in searchList" :key="data.id" sm="3">
                    <CCard class="pointer" @click="handleSelectProduct(data)">
                        <CCardBody class="p-2">
                            <CImg alt="Product Image" :src="data.image[0]" class="w-100 mb-3" />
                            <CCardSubtitle class="mb-3">{{ data.name }}</CCardSubtitle>
                            <CCardSubtitle>{{ moneyFormatter(data.price) }}</CCardSubtitle>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </CModal>
    </div>
</template>
<script>
import { CCol, CRow } from '@coreui/vue'
import axios from 'axios'
import Vue from 'vue'
import { VueEditor } from 'vue2-editor'
import {
    CONFIG_GET,
    CONFIG_UPDATE,
    PRODUCT_GET_BY_NAME
} from '../../../constants/api'
import moneyFormatter from '../../../utils/moneyFormatter'

export default {
    components: { VueEditor },
    data() {
        return {
            accessToken: sessionStorage.getItem('access_token') || '',
            addProductModal: {
                show: false,
                toIndex: null
            },
            customToolbar: [
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                ['bold', 'italic', 'underline'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ 'align': [] }],
                ['clean']
            ],
            homeProduct: {
                product: null,
                description: '',
                chinese_description: ''
            },
            isEdit: false,
            keyword: '',
            moneyFormatter,
            otherProducts: [null, null, null, null],
            searchList: []
        }
    },
    beforeMount() {
        this.fetchConfig()
    },
    methods: {
        addProduct(toIndex) {
            this.addProductModal.show = true
            this.addProductModal.toIndex = toIndex
        },
        dismissModal() {
            this.addProductModal.toIndex = null
            this.addProductModal.show = false
            this.keyword = ''
            this.searchList = []
        },
        async fetchConfig() {
            const config = await axios.get(`${CONFIG_GET}/featured_options`, {
                headers: {
                    'x-access-token': this.accessToken
                }
            })
            const { data } = config.data
            if (data) {
                this.homeProduct = data.homeProduct
                this.otherProducts = data.otherProducts
            }
        },
        handleCancel() {
            if (!window.confirm("Discard all changes?")) return
            this.isEdit = false
            this.homeProduct = {
                product: null,
                description: ''
            }
            this.otherProducts = [null, null, null, null]
            this.fetchConfig()
        },
        handleSave() {
            const {description, product, chinese_description} = this.homeProduct
            const simplifiedHomeProduct = {product: product ? product.id : null, description, chinese_description}
            const payload = {
                newConfig: JSON.stringify({
                    homeProduct: simplifiedHomeProduct,
                    otherProducts: this.otherProducts.map(p => p ? p.id : null)
                })
            }
            console.log(payload)
            axios.put(`${CONFIG_UPDATE}/featured_options`, payload, {
                headers: {
                    'x-access-token': this.accessToken
                }
            }).then(() => {
                this.fetchConfig()
                this.isEdit = false
            })
        },
        handleSelectProduct(product) {
            const { toIndex } = this.addProductModal
            const { id, name, price, image, description } = product
            const featuredProd = {
                id,
                name,
                price,
                image,
                description
            }
            if (toIndex === null) {
                this.homeProduct.product = featuredProd
            } else if (toIndex < 4) {
                this.otherProducts[toIndex] = featuredProd
            }
            this.dismissModal()
        },
        removeProduct(ofIndex) {
            if (ofIndex === null) {
                this.homeProduct.product = null
            } else if (ofIndex < 4) {
                Vue.set(this.otherProducts, ofIndex, null)
            }
        },
        searchProductByName() {
            if (!this.keyword.length) return

            axios.get(PRODUCT_GET_BY_NAME, {
                headers: {
                    'x-access-token': this.accessToken
                },
                params: {
                    limit: 8,
                    name: this.keyword,
                }
            }).then(res => {
                this.searchList = res.data.data
                this.keyword = ''
            })
        }
    }
}
</script>
<style scoped>
.button-text>span {
    margin-left: 6px;
}
</style>